import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import ExportPoolDetailsParameters from "./RandomsModel/ExportPoolDetailsParameters"

export function ExportPoolDetails(exportParams: ExportPoolDetailsParameters) {
  const params: string = JSON.stringify(exportParams)

  return ObservableFromFetch<string>("RandomTest/ExportPoolDetails", params)
}
export function GetPoolProgramYears(poolId: number): Observable<number[]> {
  const requestBody: string = new URLSearchParams({
    poolId: poolId.toString()
  }).toString()
  return ObservableFromFetch<number[]>("RandomTest/GetPoolProgramYears?" + requestBody)
}